import { render } from "./MeetingTemplates.vue?vue&type=template&id=510444cc&scoped=true&ts=true"
import script from "./MeetingTemplates.vue?vue&type=script&lang=ts"
export * from "./MeetingTemplates.vue?vue&type=script&lang=ts"

import "./MeetingTemplates.vue?vue&type=style&index=0&id=510444cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510444cc"]])

export default __exports__